<app-spinner></app-spinner>
<page-header></page-header>
<router-outlet></router-outlet>
<page-footer></page-footer>